import { render, staticRenderFns } from "./WCO.vue?vue&type=template&id=1928fc04&scoped=true"
import script from "./WCO.vue?vue&type=script&lang=js"
export * from "./WCO.vue?vue&type=script&lang=js"
import style0 from "./WCO.vue?vue&type=style&index=0&id=1928fc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928fc04",
  null
  
)

export default component.exports